import React, { useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
const designSteps = [{
  id: 'plano',
  title: 'Plano',
  badge: 'Plano Técnico',
  image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1631&q=80',
  description: 'Levantamiento y elaboración de planos técnicos con precisión milimétrica para garantizar la viabilidad de tu proyecto.'
}, {
  id: 'diseno',
  title: 'Diseño Arquitectónico',
  badge: 'Diseño Arquitectónico',
  image: 'https://images.unsplash.com/photo-1574958269340-fa927503f3dd?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80',
  description: 'Propuestas de diseño funcionales y estéticas que integran tus necesidades con las mejores prácticas arquitectónicas.'
}, {
  id: 'render',
  title: 'Render 3D',
  badge: 'Render 3D',
  image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80',
  description: 'Visualización fotorrealista de tu proyecto terminado para que puedas tomar decisiones con total confianza.'
}];
export function DesignSection() {
  const [activeStep, setActiveStep] = useState<string | null>(null);
  const whatsappDesign = 'https://wa.me/573182434499?text=Hola%20Gerfaj%2C%20vi%20su%20p%C3%A1gina%20de%20Reformas%20iniciar%20el%20proceso%20de%20dise%C3%B1o%20con%20ustedes%20';
  return <section className="py-24 md:py-32 bg-gerfaj-dark" data-id="element-34">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-35">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14" data-id="element-36">
          <h2 className="text-3xl md:text-5xl font-montserrat font-bold text-white mb-4" data-id="element-37">
            ¿Necesitas el <span className="text-gerfaj-orange" data-id="element-38">diseño</span>?
          </h2>
          <p className="text-gray-400 text-base md:text-lg max-w-2xl mx-auto" data-id="element-39">
            Del plano técnico al render fotorrealista: así visualizas tu
            proyecto antes de construir.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-40">
          {designSteps.map((step, index) => <div key={step.id} className="flex flex-col" data-id="element-41">
              <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} onClick={() => setActiveStep(activeStep === step.id ? null : step.id)} className={`group relative aspect-[16/9] md:aspect-[4/3] overflow-hidden rounded-2xl bg-gray-900 cursor-pointer border-2 transition-colors duration-300 ${activeStep === step.id ? 'border-gerfaj-orange' : 'border-transparent hover:border-gray-600'}`} data-id="element-42">
                <img src={step.image} alt={step.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 opacity-70 group-hover:opacity-90" loading="lazy" decoding="async" width={1470} height={980} data-id="element-43" />
                <div className="absolute inset-0 bg-gradient-to-t from-gerfaj-dark via-gerfaj-dark/30 to-transparent opacity-90" data-id="element-44"></div>

                {/* Title at bottom */}
                <div className="absolute bottom-0 left-0 p-5 w-full" data-id="element-45">
                  <h3 className="text-xl font-montserrat font-bold text-white" data-id="element-46">
                    {step.title}
                  </h3>
                  <div className={`h-1 bg-gerfaj-orange mt-2 rounded-full transition-all duration-300 ${activeStep === step.id ? 'w-12 opacity-100' : 'w-0 opacity-0 group-hover:w-8 group-hover:opacity-100'}`} data-id="element-47"></div>
                </div>
              </motion.div>

              {/* Description below this card */}
              <AnimatePresence data-id="element-48">
                {activeStep === step.id && <motion.div key={step.id} initial={{
              opacity: 0,
              height: 0,
              marginTop: 0
            }} animate={{
              opacity: 1,
              height: 'auto',
              marginTop: 16
            }} exit={{
              opacity: 0,
              height: 0,
              marginTop: 0
            }} className="overflow-hidden" data-id="element-49">
                    <div className="bg-white/5 border border-white/10 rounded-2xl p-5 md:p-6 text-center" data-id="element-50">
                      <p className="text-gray-300 text-sm md:text-base leading-relaxed" data-id="element-51">
                        {step.description}
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>

        {/* CTA Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="flex justify-center mt-10" data-id="element-52">
          <motion.a href={whatsappDesign} target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.04
        }} whileTap={{
          scale: 0.96
        }} className="inline-flex items-center justify-center gap-3 bg-[#FF6600] hover:bg-orange-600 text-white font-montserrat font-bold text-lg px-8 py-4 rounded-2xl shadow-[0_0_40px_rgba(255,102,0,0.5)] transition-colors duration-300 w-[90%] sm:w-auto min-h-[60px]" data-id="element-53">
            <MessageCircle className="w-6 h-6" data-id="element-54" />
            ¡Quiero mi diseño!
          </motion.a>
        </motion.div>
      </div>
    </section>;
}